(function () {
  function isVisible(el) {
    if (!el) return false;
    if (el.classList.contains('hide_element')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var section = el.closest('.shopify-section');
    if (section && window.getComputedStyle(section).display === 'none') return false;
    return el.getBoundingClientRect().height > 0;
  }

  function updateGeoBannerHeight() {
    var geo = document.getElementById('store_locator_box');
    var height = isVisible(geo) ? geo.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--geo-banner-height', height + 'px');
    return height;
  }

  function updateAnnouncementHeight(geoHeight) {
    var bar = document.querySelector('.announcement-bar');
    if (!isVisible(bar)) {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    var rect = bar.getBoundingClientRect();
    var visibleTop = Math.max(geoHeight, 0);
    var height = Math.max(0, Math.min(rect.bottom - visibleTop, bar.offsetHeight));
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }

  function updateOffsets() {
    var geoHeight = updateGeoBannerHeight();
    updateAnnouncementHeight(geoHeight);
  }

  var scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      updateOffsets();
    });
  }

  updateOffsets();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('orientationchange', scheduleUpdate);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateOffsets);
  }

  new MutationObserver(scheduleUpdate).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
    childList: true
  });
})();
